import React from 'react';
import { Link } from 'react-router-dom'; // Ensure you're using React Router for navigation
import './Projects.css';

// Sample data for projects
const projects = [
  {
    id: 1,
    title: "Coil Gun",
    description: "I designed and built a coil gun from scratch. This is my current project. A more detailed description is coming soon!",
    image: require('./../assets/work2.png'), // Add an image to your assets folder
    link: "/projects/uwb-tracking-system",
  },
  {
    id: 2,
    title: "Laser Turret",
    description: "Ever wanted some security for your room from unwanted visitors? Look no further than my carfully designed laser turret and will home onto the unexpected guest and activate a high powered laser!",
    image: require('./../assets/work2.png'), // Add an image to your assets folder
    link: "/projects/pedestrian-safety-system",
  },
  {
    id: 3,
    title: "Automatic Light Switch",
    description: "Ever felt too lazy to get out of bed to turn on or off the light at night or in the morning? Well I have the perfect solution for you - a remote controlled lighting system!",
    image: require('./../assets/work2.png'), // Add an image to your assets folder
    link: "/projects/ai-trading-insights",
  },
];

export function Projects() {
    return (
      <div className="projects">
        <div className="projects__note">Explore some of my engineering projects!</div>
        <div className="projects__grid">
          {projects.map((project) => (
            <div key={project.id} className="project__item">
              <img src={project.image} alt={project.title} className="project__image" />
              <div className="project__content">
                <h2>{project.title}</h2>
                <p>{project.description}</p>
                <Link to={project.link} className="project__link">
                  Learn More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }